import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => (
  <div>
    <nav
      className="navbar fixed-top navbar-expand-lg"
      style={{
        backgroundColor: "#343A40",
        padding: "15px 20px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
      }}
    >
      <div className="container">
        <Link
          className="navbar-brand"
          to="/"
          style={{
            color: "#E87400",
            fontWeight: "bold",
            fontSize: "1.8rem",
            letterSpacing: "0.05em",
          }}
        >
          myCCWTT
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item mx-2">
              <Link
                className="nav-link"
                to="/"
                style={{ color: "#FFFFFF", fontSize: "1.1rem" }}
              >
                Home
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link
                className="nav-link"
                to="/about"
                style={{ color: "#FFFFFF", fontSize: "1.1rem" }}
              >
                About Us
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link
                className="nav-link"
                to="/technology"
                style={{ color: "#FFFFFF", fontSize: "1.1rem" }}
              >
                Our Technology
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link
                className="nav-link"
                to="/contact"
                style={{ color: "#FFFFFF", fontSize: "1.1rem" }}
              >
                Contact Us
              </Link>
            </li>
          </ul>

          <ul className="navbar-nav ml-lg-4">
            <li className="nav-item">
              <Link
                to="/register"
                className="btn btn-outline-warning mx-1"
                style={{
                  fontSize: "1rem",
                  padding: "8px 15px",
                  color: "#FFFFFF",
                  borderColor: "#E87400",
                }}
              >
                B2B Register
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/login"
                className="btn btn-outline-warning mx-1"
                style={{
                  fontSize: "1rem",
                  padding: "8px 15px",
                  color: "#FFFFFF",
                  borderColor: "#E87400",
                }}
              >
                B2B Log In
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
);

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Header/Navbar/navbar.js